<template>
  <button class="close-menu">
    <span class="sr-only">Close menu for {{ name }}</span>
    <span aria-hidden>Close</span>
    <i class="far fa-times"></i>
  </button>
</template>
<script>
  export default {
    name: 'CloseMobileMenu',
    props: {
      name: String
    }
  }
</script>

<style lang="scss" scoped>
  .close-menu {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0;
    border: 0;
    background: #333 !important; /* OLD SeaGOV banner has some super strong css  */
    color: #fff;
    padding: 10px 20px !important; /* OLD SeaGOV banner has some super strong css  */
    

    svg {
      width: 13px;
      height: 20px;
      margin-left: 10px; 
      color: #fff;
    }

    &:hover span {
      text-decoration: underline;
    }
  }
</style>
